
<template>
  <base-modal-ex :active="active"
    has-modal-card
    @close="close">
    <header class="modal-card-head">
      <p class="modal-card-title is-flex-items-center">
        <span>New Company</span>
      </p>
    </header>
    <section class="modal-card-body">
      <div class="buttons is-centered">
        <button class="button is-primary is-medium"
          @click="create('hq')">
          <span class="icon is-small">
            <span class="mso mso-24px">apartment</span>
          </span>
          <span>Create HQ Company</span>
        </button>
        <button class="button is-primary is-medium"
          @click="create('normal')">
          <span class="icon is-small">
            <span class="mso mso-24px">domain</span>
          </span>
          <span>Create Normal/Branch Company</span>
        </button>
      </div>
    </section>
    <footer class="modal-card-foot is-flex is-justify-content-flex-end">
      <div class="buttons">
        <button class="button tooltip"
          @click="close"
          data-tooltip="Close">
          <span class="icon">
            <span class="mso mso-20px">close</span>
          </span>
          <span>Close</span>
        </button>
      </div>
    </footer>
  </base-modal-ex>
</template>

<script>
import BaseModalEx from '@/components/BulmaModal/BaseModalEx.vue'

export default {
  name: 'CompanyNewModal',
  components: {
    BaseModalEx
  },
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    create(companyType) {
      this.$emit('create', companyType)
    }
  }
}
</script>
